/* eslint-disable radix */
class ProductDropDownItemElement extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.initDropdown();
  }

  disconnectedCallback() {
    // Cleanup: remove the event listener when the element is removed from the DOM
    const header = this.querySelector(".product-dropdown-item__header");
    if (header) {
      header.removeEventListener("click", this.handleClick);
    }
  }

  initDropdown() {
    const header = this.querySelector(".product-dropdown-item__header");
    if (header) {
      header.addEventListener("click", this.handleClick);
    }
  }

  handleClick() {
    this.classList.toggle("product-dropdown-item--open");
  }
}

customElements.define("product-dropdown-item", ProductDropDownItemElement);
